import styled from 'styled-components';

export const SectionContainer = styled.section`
  padding: 5rem 0;
  overflow: hidden;
`;

export const LeftContent = styled.div`
  flex: 1;
  padding: 2rem;
`;

export const RightContent = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
`;

export const AppImage = styled.img`
  max-width: 100%;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
`; 